import { render, staticRenderFns } from "./ReportK.vue?vue&type=template&id=912ba7d2&scoped=true&"
import script from "./ReportK.vue?vue&type=script&lang=js&"
export * from "./ReportK.vue?vue&type=script&lang=js&"
import style0 from "./ReportK.vue?vue&type=style&index=0&id=912ba7d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "912ba7d2",
  null
  
)

export default component.exports